import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-single-file",
  "use": "icon-single-file-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-single-file\"><defs><style></style></defs><path d=\"M679.814 62.381H128.692v897.177h768.434V255.079L679.814 62.381zM203.758 890.606V131.333h414.026v188.205H822.06v571.068H203.758z\" /><path d=\"M293.825 417.364H746.64v67.229H293.825zm0 160.345H746.64v67.229H293.825zm0 160.345H746.64v67.229H293.825z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol